import { useMatch } from 'react-router-dom';
import { CLASSROOM_FILTER_PARAM } from './calendar/calendarUtils';

/**
 * Paths under /my-classrooms.
 *
 * The second segment there is normally a classroom id, but not always — the global calendar
 * lives at /my-classrooms/calendar. Anything that reads a classroom id out of the URL has to
 * go through `useActiveClassroomId` so those pages aren't mistaken for a classroom.
 */

export const CALENDAR_SEGMENT = 'calendar';
export const CALENDAR_PATH = `/my-classrooms/${CALENDAR_SEGMENT}`;

/** Second segments under /my-classrooms that are pages, not classroom ids. */
export const RESERVED_SEGMENTS = new Set([CALENDAR_SEGMENT]);

/** The global calendar, optionally pre-filtered to some classrooms. */
export const calendarPath = (classroomIds = []) =>
    classroomIds.length > 0
        ? `${CALENDAR_PATH}?${CLASSROOM_FILTER_PARAM}=${classroomIds.map(encodeURIComponent).join(',')}`
        : CALENDAR_PATH;

/** True on the global calendar page. */
export const useIsCalendarPage = () => Boolean(useMatch(CALENDAR_PATH));

/** The classroom id in the current URL, or null on /my-classrooms itself and its own pages. */
export const useActiveClassroomId = () => {
    const match = useMatch('/my-classrooms/:classroomId/*');
    const classroomId = match?.params.classroomId;
    return classroomId && !RESERVED_SEGMENTS.has(classroomId) ? classroomId : null;
};
